import AppRoute from './AppRouteContainer';

export default AppRoute;
